var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * https://github.com/john-doherty/swiped-events
         * issues about safari vertical scroll on horizontal swiping
         * https://github.com/akiran/react-slick/issues/1281
         * https://github.com/akiran/react-slick/issues/1240
         */
        window.utils.events = window.utils.events || {};
        window.utils.events.passiveListener = function () {
            var e = !1;
            try {
                var i = Object.defineProperty({}, "passive", {
                    get: function get() {
                        e = !0;
                    }
                });
                t.addEventListener("testPassiveListener", null, i);
            } catch (e) {}
            return e;
        }();
        window.utils.events.swipe = {
            disable: function disable(element) {
                element.setAttribute('data-swipe-ignore', 'true');
            },
            enable: function enable(element) {
                element.setAttribute('data-swipe-ignore', 'false');
            },
            onTouchStart: handleTouchStart
        };

        // if ('initCustomEvent' in document.createEvent('CustomEvent')) {
        //     window.CustomEvent = function(eventType, params) {
        //         params = params || {
        //             bubbles: false, // stopPropagation
        //             cancelable: false, // without that flag preventDefault doesn't work
        //             detail: null
        //         };
        //         const event = document.createEvent('CustomEvent');
        //         event.initCustomEvent(eventType, params.bubbles, params.cancelable, params.detail);
        //         return event;
        //     };
        //     window.CustomEvent.prototype = window.Event.prototype;
        // }

        // document.addEventListener('touchstart', handleTouchStart, false);
        // document.addEventListener('touchmove', handleTouchMove, false);
        // document.addEventListener('touchend', handleTouchEnd, false);

        var startX = 0;
        var startY = 0;
        var diffX = 0;
        var diffY = 0;
        var startTime = 0;
        var startElement = null;
        var preventScroll = null;

        function resetSwipe() {
            startX = 0;
            startY = 0;
            diffX = 0;
            diffY = 0;
            startTime = 0;
            startElement = null;
            preventScroll = null;
        }

        var settings = {

            // More time than this, and it isn't a swipe.
            durationThreshold: 1000,

            // Swipe horizontal displacement must be more than this.
            horizontalDistanceThreshold: 30,

            // Swipe vertical displacement must be less than this.
            verticalDistanceThreshold: 30,

            // prevent vertical scroll
            preventBodyScrollThreshold: 5
        };

        function handleTouchStart(event) {
            if (event.target.getAttribute('data-swipe-ignore') === 'true' || !event.touches || event.touches.length !== 1) {
                return;
            }

            startElement = event.target;
            startTime = Date.now();
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            diffX = 0;
            diffY = 0;

            // startElement.addEventListener('touchmove', handleTouchMove, utils.events.passiveListener ? {
            //     passive: false,
            //     capture: capture
            // } : capture);

            startElement.addEventListener('touchmove', handleTouchMove, false);
            startElement.addEventListener('touchend', handleTouchEnd, false);
        }

        function removeEventListeners() {
            if (startElement) {
                startElement.removeEventListener('touchmove', handleTouchMove);
                startElement.removeEventListener('touchend', handleTouchEnd);
            }
        }

        function handleTouchMove(event) {
            diffX = startX - event.touches[0].clientX;
            diffY = startY - event.touches[0].clientY;

            var swipeLeftRightLength = Math.abs(diffX);
            var swipeUpDownLength = Math.abs(diffY);

            if (preventScroll === null && (swipeUpDownLength > settings.preventBodyScrollThreshold || swipeLeftRightLength > settings.preventBodyScrollThreshold)) {
                if (swipeLeftRightLength > swipeUpDownLength) {
                    preventScroll = true;
                }
            }
        }

        function handleTouchEnd(event) {
            var swipeTimeout = settings.durationThreshold;

            var timeDiff = Date.now() - startTime;
            var eventType = '';
            if (Math.abs(diffX) > Math.abs(diffY)) {
                // horizontal
                if (Math.abs(diffX) > settings.horizontalDistanceThreshold && timeDiff < swipeTimeout) {
                    if (diffX > 0) {
                        eventType = 'swipe-left';
                    } else {
                        eventType = 'swipe-right';
                    }
                }
            }
            // else {
            //     // vertical
            //     if (Math.abs(diffY) > settings.verticalDistanceThreshold && timeDiff < swipeTimeout) {
            //         if (diffY > 0) {
            //             eventType = 'swipe-up';
            //         } else {
            //             eventType = 'swipe-down';
            //         }
            //     }
            // }
            if (eventType !== '') {
                startElement.dispatchEvent(new CustomEvent(eventType, {
                    bubbles: true,
                    cancelable: true
                }));
            }

            removeEventListeners();
            resetSwipe();
        }
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var Location = require('./Location');
        window.CityItem = require('./CityItem');
        var pixelTracker = require('./PixelTracker');
        var CITY_ALMATY = 1;

        var BaseCitySelect = function () {
            function BaseCitySelect() {
                _classCallCheck(this, BaseCitySelect);

                this.location = new Location();
                this.cityElement = null; // main site city
                /**
                 * @type {boolean}
                 * @protected
                 */
                this.mainMenuOpenLock = false;
            }

            /**
             * @protected
             */


            _createClass(BaseCitySelect, [{
                key: "checkLocation",
                value: function checkLocation() {
                    var _this = this;

                    if (this.isLocatedUser()) {
                        this.fitSiteToCity(app.city.id, true);
                        // fb counter
                        this.initializePixel(app.realCity.name);
                    } else {
                        window.addEventListener('load', function () {
                            if (window.app.isGeolocationEnabled) {
                                _this.location.get(function (locatedCityName) {
                                    _this.setCity(locatedCityName, true, true);
                                    _this._onLocationCallback(locatedCityName);
                                });
                            } else {
                                _this._onLocationCallback('');
                            }
                        }, { once: true });
                    }
                }

                /**
                 *
                 * @param {string} locatedCityName
                 * @private
                 */

            }, {
                key: "_onLocationCallback",
                value: function _onLocationCallback(locatedCityName) {
                    // fb counter
                    this.initializePixel(locatedCityName);

                    var detectedCity = locatedCityName !== '' ? CityItem.findByName(locatedCityName) : null;
                    if (!detectedCity) {
                        detectedCity = this.getDefaultCity();
                    }

                    this.showDetectedCityConfirm(detectedCity.id);
                }

                /**
                 * @deprecated
                 * @return {CityItem|null}
                 */

            }, {
                key: "getCurrent",
                value: function getCurrent() {
                    return CityItem.getCurrent();
                }

                /**
                 * @deprecated
                 * @param {number} cityId
                 * @return {CityItem|null}
                 */

            }, {
                key: "findById",
                value: function findById(cityId) {
                    return CityItem.findById(cityId);
                }

                /**
                 * @deprecated
                 * @param {string} cityName
                 * @return {CityItem|null}
                 */

            }, {
                key: "findByName",
                value: function findByName(cityName) {
                    return CityItem.findByName(cityName);
                }

                /**
                 * @deprecated
                 * @param {number} cityId
                 * @return {boolean}
                 */

            }, {
                key: "contactExist",
                value: function contactExist(cityId) {
                    return CityItem.contactExist(cityId);
                }

                /**
                 * @return {boolean}
                 */

            }, {
                key: "isLocatedUser",
                value: function isLocatedUser() {
                    return app.city.name && app.realCity.name;
                }

                /**
                 * @param {string} cityName
                 * @param {boolean} isReal
                 * @param {boolean|undefined} runCallback
                 */

            }, {
                key: "setCity",
                value: function setCity(cityName, isReal, runCallback) {
                    var _this2 = this;

                    app.city.name = cityName;
                    if (isReal) {
                        app.realCity.name = cityName;
                    }
                    if ('undefined' === typeof runCallback) {
                        runCallback = true;
                    }
                    $.post('/site/set-city', {
                        city: cityName,
                        real: isReal ? 1 : ''
                    }, function (data) {
                        if (runCallback) {
                            if (isReal && data.real) {
                                app.realCity = data.real;
                            }
                            if (data.city) {
                                app.city = data.city;
                                // onLocation analog
                                _this2.onAfterSetCity();
                            }
                        }
                    }, 'json');
                }

                /**
                 * Обработчики, геолокация
                 */

            }, {
                key: "init",
                value: function init() {}

                /**
                 * @param {number} cityId
                 * @param {boolean} onlyContacts
                 * @protected
                 */

            }, {
                key: "fitSiteToCity",
                value: function fitSiteToCity(cityId, onlyContacts) {}

                /**
                 * Показывает подтверждение определения города
                 * @param {number} cityId
                 * @protected
                 */

            }, {
                key: "showDetectedCityConfirm",
                value: function showDetectedCityConfirm(cityId) {}
            }, {
                key: "isLocationConfirmPromptShown",
                value: function isLocationConfirmPromptShown() {
                    return true;
                }
            }, {
                key: "onAfterSetCity",
                value: function onAfterSetCity() {}
            }, {
                key: "initializePixel",
                value: function initializePixel(realCityName) {
                    if (!pixelTracker.exist(realCityName)) {
                        realCityName = this.getDefaultCity().name;
                    }
                    pixelTracker.init(realCityName);
                }

                /**
                 * Алматы
                 * @return {CityItem}
                 */

            }, {
                key: "getDefaultCity",
                value: function getDefaultCity() {
                    return this.findById(CITY_ALMATY);
                }
            }]);

            return BaseCitySelect;
        }();

        module.exports = BaseCitySelect;
    }, { "./CityItem": 2, "./Location": 3, "./PixelTracker": 4 }], 2: [function (require, module, exports) {
        var CityItem = function () {
            function CityItem(city) {
                _classCallCheck(this, CityItem);

                /** {number} */
                this.id = Number(city.id);
                /** {string} */
                this.name = city.name;
                /** {number|null} */
                this.depart_id = city.depart_id ? Number(city.depart_id) : null;
                /** {boolean} */
                this.scheme = city.scheme; // Схема проезда
                /** {boolean} */
                this.contactsHidden = city.contactsHidden;
                this.currentPhone = {
                    phone: city.currentPhone.phone,
                    href: city.currentPhone.href,
                    linkHtml: city.currentPhone.linkHtml,
                    hiddenHtml: city.currentPhone.hiddenHtml
                };
                this.altPhone = {
                    phone: city.altPhone.phone,
                    href: city.altPhone.href,
                    linkHtml: city.altPhone.linkHtml,
                    hiddenHtml: city.altPhone.hiddenHtml
                };
                this.socials = {
                    instagram: city.socials.instagram, // url
                    facebook: city.socials.facebook // url
                };
                /**
                 * @type {{href: string}}
                 */
                this.whatsapp = {
                    href: city.whatsapp.href
                };
                /** {boolean} */
                this.hasHoliday = !!city.hasHoliday;
            }

            /**
             * @param {string} type - alt|current
             * @return {string}
             */


            _createClass(CityItem, [{
                key: "getPhoneView",
                value: function getPhoneView(type) {
                    return type === 'alt' ? this.getAltPhoneView() : this.getCurrentPhoneView();
                }
            }, {
                key: "getCurrentPhoneView",
                value: function getCurrentPhoneView() {
                    return this.contactsHidden ? this.currentPhone.hiddenHtml : this.currentPhone.linkHtml;
                }
            }, {
                key: "getAltPhoneView",
                value: function getAltPhoneView() {
                    return this.contactsHidden ? this.altPhone.hiddenHtml : this.altPhone.linkHtml;
                }

                /**
                 * @private
                 * @param {string} field
                 * @param {number|string} value
                 * @return {*}
                 */

            }], [{
                key: "_findByField",
                value: function _findByField(field, value) {
                    var city = null;
                    for (var i in app.cities) {
                        if (value === app.cities[i][field]) {
                            city = new CityItem(app.cities[i]);
                            break;
                        }
                    }

                    return city;
                }

                /**
                 * @param {string} cityName
                 * @return {CityItem|null}
                 */

            }, {
                key: "findByName",
                value: function findByName(cityName) {
                    return CityItem._findByField('name', cityName);
                }

                /**
                 * @param {number} departId
                 * @return {CityItem|null}
                 */

            }, {
                key: "findByDepartId",
                value: function findByDepartId(departId) {
                    return CityItem._findByField('depart_id', departId);
                }

                /**
                 * @param {number} cityId
                 * @return {CityItem|null}
                 */

            }, {
                key: "findById",
                value: function findById(cityId) {
                    return this.contactExist(cityId) ? new CityItem(app.cities[cityId]) : null;
                }

                /**
                 * @param {number} cityId
                 * @return {boolean}
                 */

            }, {
                key: "contactExist",
                value: function contactExist(cityId) {
                    return 'undefined' !== typeof app.cities[cityId];
                }

                /**
                 * @return {CityItem|null}
                 */

            }, {
                key: "getCurrent",
                value: function getCurrent() {
                    var cityItem = null;
                    if (app.city) {
                        var city = this.findById(app.city.id);
                        cityItem = new CityItem(city);
                    }

                    return cityItem;
                }
            }]);

            return CityItem;
        }();

        module.exports = CityItem;
    }, {}], 3: [function (require, module, exports) {
        var Location = function () {
            function Location() {
                _classCallCheck(this, Location);

                this.locatedCity = null;
            }

            /**
             * @param {function} callback
             */


            _createClass(Location, [{
                key: "get",
                value: function get(callback) {
                    var _this3 = this;

                    window.ymapGeolocationLoader.load(function () {
                        if (typeof ymaps === 'undefined' || !ymaps.geolocation) {
                            console.log('ymaps undefined, geolocation off');
                        } else if (_this3.locatedCity !== null) {
                            callback(_this3.locatedCity);
                        } else {
                            var self = _this3;
                            ymaps.ready(function () {
                                ymaps.geolocation.get({ provider: 'yandex' }).then(function (result) {
                                    var locatedCity = result.geoObjects.get(0).properties.get('name');
                                    if (locatedCity === 'Нур-Султан (Астана)') {
                                        locatedCity = 'Астана';
                                        console.log('geo changed', locatedCity);
                                    } else {
                                        console.log('geo', locatedCity);
                                    }
                                    self.locatedCity = locatedCity;
                                    callback(locatedCity);
                                });
                            });
                        }
                    });
                }
            }]);

            return Location;
        }();

        module.exports = Location;
    }, {}], 4: [function (require, module, exports) {
        var PixelTracker = function () {
            function PixelTracker() {
                _classCallCheck(this, PixelTracker);

                this.isInitialized = false;
            }

            /**
             * @param {string} realCityName
             * @return {boolean}
             */


            _createClass(PixelTracker, [{
                key: "init",
                value: function init(realCityName) {
                    if (this.isInitialized) {
                        return false;
                    }
                    var pixelId = this.getId(realCityName);
                    if (pixelId !== '') {
                        this.isInitialized = true;
                        !function (f, b, e, v, n, t, s) {
                            if (f.fbq) return;
                            n = f.fbq = function () {
                                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                            };
                            if (!f._fbq) f._fbq = n;
                            n.push = n;
                            n.loaded = !0;
                            n.version = '2.0';
                            n.queue = [];
                            t = b.createElement(e);
                            t.async = !0;
                            t.src = v;
                            s = b.getElementsByTagName(e)[0];
                            s.parentNode.insertBefore(t, s);
                        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', pixelId); // Insert your pixel ID here.
                        fbq('track', 'PageView');
                    }
                    var srcId = null;
                    if (window.app.updateSourceId !== undefined) {
                        srcId = window.app.updateSourceId;
                    } else if (!document.referrer) {
                        srcId = 33;
                    }
                    if (srcId !== null) {
                        $.get('/site/updateCounter', {
                            src_id: srcId,
                            city_id: window.app.city.id
                        });
                    }
                    return true;
                }

                /**
                 * @param {string} realCityName
                 * @return {string}
                 */

            }, {
                key: "getId",
                value: function getId(realCityName) {
                    var pixelId = '';
                    switch (realCityName) {
                        case 'Алматы':
                            //
                            pixelId = '222300428196785';
                            break;
                        case 'Нур-Султан (Астана)':
                        case 'Нур-Султан':
                        case 'Астана':
                            pixelId = '718486491649332';
                            break;
                        case 'Актобе':
                            //
                            pixelId = '480493949032847';
                            break;
                    }

                    return pixelId;
                }

                /**
                 * @param {string} realCityName
                 * @return {boolean}
                 */

            }, {
                key: "exist",
                value: function exist(realCityName) {
                    return this.getId(realCityName) !== '';
                }
            }]);

            return PixelTracker;
        }();

        module.exports = new PixelTracker();
    }, {}], 5: [function (require, module, exports) {
        window.modal = require('../../../include/_js/modal');
        window.widgetStorage = require('../../../include/_js/widget');
        var PseudoSelect = require('../../../include/_js/PseudoSelect');
        var CitySelect = require('../../../include/_js/CitySelect');
        var Popover = require('../../../include/_js/popover').Popover;

        new PseudoSelect();
        window.pseudoSelect = {
            getLinkItem: PseudoSelect.getLinkItem,
            getButtonItem: PseudoSelect.getButtonItem,
            getLabel: PseudoSelect.getLabel,
            valueExist: PseudoSelect.valueExist,
            renderItems: PseudoSelect.renderItems
        };
        window.popover = {
            show: function show(container, content, params) {
                return new Popover(container, content, params);
            }
        };

        // site city select
        window.citySelect = new CitySelect();
        window.citySelect.init();
    }, { "../../../include/_js/CitySelect": 6, "../../../include/_js/PseudoSelect": 7, "../../../include/_js/modal": 9, "../../../include/_js/popover": 15, "../../../include/_js/widget": 16 }], 6: [function (require, module, exports) {
        var BaseCitySelect = require('../../../include/_js/BaseCitySelect');

        var CitySelect = function (_BaseCitySelect) {
            _inherits(CitySelect, _BaseCitySelect);

            function CitySelect() {
                _classCallCheck(this, CitySelect);

                return _possibleConstructorReturn(this, (CitySelect.__proto__ || Object.getPrototypeOf(CitySelect)).apply(this, arguments));
            }

            _createClass(CitySelect, [{
                key: "init",
                value: function init() {
                    var _this5 = this;

                    this.cityElement = $('#site-city-select');

                    this.cityElement.on('change', function (e) {
                        var cityId = e.currentTarget.value;
                        var city = _this5.findById(cityId);
                        $(window).trigger('onLocation', city);
                        _this5.setCity(city.name, !_this5.isLocatedUser(), true);
                    });

                    this.attachListeners();
                    this.checkLocation();
                }
            }, {
                key: "attachListeners",
                value: function attachListeners() {
                    var _this6 = this;

                    var selfSelect = this;
                    $(window).on('onLocation', function (event, city) {
                        if (!city) {
                            return false;
                        }
                        _this6.fitSiteToCity(city.id, false);
                        window.tracking.callTrackingRefresh();
                    });

                    var $selectCityForm = $('#city-detected-form');

                    if ($selectCityForm.length) {
                        $('#city-detected-form .accept-button').one('click', function () {
                            var cityName = $('#city-detected-form .city-name').data('city-name');
                            selfSelect.setCity(cityName, !selfSelect.isLocatedUser(), true);
                            $('#city-detected-form').remove();
                        });

                        $('#city-detected-form .change-button').on('click', function () {
                            $('#city-detected-form').remove();
                            selfSelect.cityElement.trigger('psEvent.open');
                        });

                        $selectCityForm.on('click', function (e) {
                            var $target = $(e.target);
                            var $contentWrapper = $target.closest('#city-detected-content');
                            if (!$contentWrapper.length) {
                                $selectCityForm.remove();
                            }
                        });
                    }
                }

                /**
                 * @inheritDoc
                 */

            }, {
                key: "fitSiteToCity",
                value: function fitSiteToCity(cityId, onlyContacts) {
                    var city = this.findById(cityId);
                    if (!city) {
                        return false;
                    }

                    // Установка контактов
                    this.drawContacts(city.id);

                    if (onlyContacts) {
                        return;
                    }

                    // TODO: set subscription form city

                    // Подмена цен в меню
                    $.post('/country/get-prices', {}, function (data) {
                        var itemsHtml = '';
                        var country = void 0;
                        var i = void 0;
                        for (i in data) {
                            country = data[i];
                            itemsHtml += '<li class="js-replace-on-city-change">' + '<a href="/tours/' + country.name_en + '">' + '<span>' + country.name + (country.minPrice ? '<span class="min-price-value">' + country.minPrice + '</span>' : '') + '</span>' + '</a>' + '</li>';
                        }
                        if (itemsHtml !== '') {
                            var $list = $('#site-menu-tours-items');
                            $list.find('.js-replace-on-city-change').remove();
                            $list.prepend(itemsHtml);
                        }
                    });
                }

                /**
                 * @inheritDoc
                 */

            }, {
                key: "showDetectedCityConfirm",
                value: function showDetectedCityConfirm(cityId) {
                    if (this.contactExist(cityId)) {
                        var city = this.findById(cityId);
                        var $form = $('#city-detected-form');
                        $form.find('.city-name').html(city.name).data('city-name', city.name);
                        $form.removeClass('hidden');
                        var date = new Date();
                        date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
                        var expires = "expires=" + date.toUTCString();
                        document.cookie = 'city-detected-popup=true; ' + expires + '; path=/';
                        setTimeout(function () {
                            $form.addClass('animated-in');
                        }, 50);
                    }
                }
            }, {
                key: "isLocationConfirmPromptEnabled",
                value: function isLocationConfirmPromptEnabled() {
                    return !this.isLocatedUser() || $('#city-detected-form').hasClass('hidden');
                }

                /**
                 * @protected
                 */

            }, {
                key: "onAfterSetCity",
                value: function onAfterSetCity() {
                    $(window).trigger('onAfterSetCity', this.getCurrent());
                }

                /**
                 * @param cityId
                 * @return {boolean}
                 * @private
                 */

            }, {
                key: "drawContacts",
                value: function drawContacts(cityId) {
                    if (!CityItem.contactExist(cityId)) {
                        return false;
                    }

                    var city = CityItem.findById(cityId);

                    // Меняем номер whatsapp
                    var $whatsappButton = $('.whatsapp-button');
                    if ($whatsappButton.length) {
                        if (city.whatsapp.href === '') {
                            $whatsappButton.addClass('hidden');
                        } else {
                            $whatsappButton.removeClass('hidden');
                            $whatsappButton.attr('href', city.whatsapp.href);
                        }
                    }

                    // меняем основной номер
                    $('.current-city-phone-wrapper').each(function () {
                        var type = this.getAttribute('data-type');
                        this.innerHTML = city.getPhoneView(type);
                    });

                    $('.js-url__instagram').attr('href', city.socials.instagram);
                    $('.js-url__fb').attr('href', city.socials.facebook);
                }
            }]);

            return CitySelect;
        }(BaseCitySelect);

        module.exports = CitySelect;
    }, { "../../../include/_js/BaseCitySelect": 1 }], 7: [function (require, module, exports) {
        var PseudoSelect = function () {
            function PseudoSelect() {
                _classCallCheck(this, PseudoSelect);

                this.$openedNowInput = null;
                this._attachDOMHandlers();
            }

            _createClass(PseudoSelect, [{
                key: "_open",


                /**
                 * @param {ModalParams} [modalParams]
                 * @private
                 */
                value: function _open(modalParams) {
                    var $parent = this.$openedNowInput.closest('.pseudo-select');
                    var $valuesWrap = $parent.find('.values-wrap');
                    if ($valuesWrap.length) {
                        var params = {
                            content: $valuesWrap.html(),
                            contentPosition: window.modal.contentPosition.TOP
                        };
                        if (modalParams) {
                            params.onBeforeClose = modalParams.onBeforeClose;
                        }
                        window.modal.open(new window.modal.Params(params));
                    }
                }
            }, {
                key: "_toggleEnabledPseudoSelect",
                value: function _toggleEnabledPseudoSelect($input, enable) {
                    var $parent = $input.closest('.pseudo-select');
                    var $openBtn = $parent.find('.pseudo-select__open');
                    $input.prop('disabled', !enable);
                    $openBtn.prop('disabled', !enable);
                    if (enable) {
                        $openBtn.removeClass('disabled');
                    } else {
                        $openBtn.addClass('disabled');
                    }
                }
            }, {
                key: "_attachDOMHandlers",


                /**
                 * @private
                 */
                value: function _attachDOMHandlers() {
                    var self = this;
                    $('body').on('click', '.pseudo-select__open', function (e) {
                        var $parent = $(this).closest('.pseudo-select');
                        self.$openedNowInput = $parent.find('.ps-hidden-value');
                        self._open();
                        e.stopPropagation();
                    }).on('psEvent.open', '.ps-hidden-value', function (e, modalParams) {
                        self.$openedNowInput = $(this);
                        self._open(modalParams);
                        e.stopPropagation();
                    }).on('click', '.ps-button', function () {
                        var clickedValue = $(this).closest('.ps-item').data('value');
                        var currentValue = self.$openedNowInput.val();
                        if (!PseudoSelect._isEqual(clickedValue, currentValue)) {
                            self.$openedNowInput.val(clickedValue);
                            self.$openedNowInput.trigger('change');
                        }
                    }).on('change', '.ps-hidden-value', function () {
                        var $parent = $(this).parent();
                        $parent.find('.pseudo-select__open .ps-label').text(PseudoSelect.getLabel($(this)));
                    }).on('psEvent.set', '.ps-hidden-value', function (event, value) {
                        var $selfInput = $(this);
                        if (!PseudoSelect._isEqual(this.value, value) && PseudoSelect.valueExist($selfInput, value)) {
                            this.value = value;
                            $selfInput.trigger('change');
                        }
                    }).on('psEvent.reset', '.ps-hidden-value', function () {
                        this.value = '';
                        $(this).trigger('change');
                    }).on('psEvent.disable', '.ps-hidden-value', function () {
                        self._toggleEnabledPseudoSelect($(this), false);
                    }).on('psEvent.enable', '.ps-hidden-value', function () {
                        self._toggleEnabledPseudoSelect($(this), true);
                    }).on('click', 'a.ps-button', function () {
                        window.showPagePreloader();
                    });
                }
            }], [{
                key: "getButtonItem",
                value: function getButtonItem(value, label, checked) {
                    var checkedClass = checked ? ' checked' : '';
                    return "<li class=\"ps-item checked\" data-value=\"" + value + "\"><button type=\"button\" class=\"ps-button m-popup__close" + checkedClass + "\">" + label + "</button></li>";
                }
            }, {
                key: "getLinkItem",
                value: function getLinkItem(value, label, href, checked) {
                    var checkedClass = checked ? ' checked' : '';
                    return "<li class=\"ps-item checked\" data-value=\"" + value + "\"><a href=\"" + href + "\" class=\"ps-button m-popup__close" + checkedClass + "\">" + label + "</a></li>";
                }

                /**
                 * @param $input
                 * @return {string}
                 */

            }, {
                key: "getLabel",
                value: function getLabel($input) {
                    if (!$input.hasClass('ps-hidden-value')) {
                        return 'N/A';
                    }
                    var value = $input.val();
                    var $parent = $input.parent();
                    $parent.find('.ps-item.checked').removeClass('checked');
                    var $option = $parent.find('.ps-item[data-value="' + value + '"]');
                    $option.addClass('checked');
                    var $textElement = $option.find('.ps-button');
                    var label = $textElement.data('label');
                    if (typeof label === 'undefined' || label === '') {
                        label = $textElement.text();
                    }

                    return label;
                }
            }, {
                key: "valueExist",
                value: function valueExist($input, value) {
                    var $parent = $input.closest('.pseudo-select');
                    return $parent.find('.ps-item[data-value="' + value + '"]').length === 1;
                }

                /**
                 *
                 * @param {string|number} newValue
                 * @param {string|number} currentValue
                 * @return {boolean}
                 * @private
                 */

            }, {
                key: "_isEqual",
                value: function _isEqual(newValue, currentValue) {
                    var newValueInt = parseInt(newValue, 10);
                    if (!isNaN(newValueInt)) {
                        newValue = newValueInt;
                        currentValue = parseInt(currentValue, 10);
                    }

                    return newValue === currentValue;
                }
            }]);

            return PseudoSelect;
        }();

        module.exports = PseudoSelect;
    }, {}], 8: [function (require, module, exports) {
        var WidgetStorage = function () {
            function WidgetStorage() {
                _classCallCheck(this, WidgetStorage);

                this.currentWidgets = [];
            }

            /**
             * Добавление виджета
             * @param name
             */


            _createClass(WidgetStorage, [{
                key: "add",
                value: function add(name) {
                    if (!this.exist(name)) {
                        this.currentWidgets.push(name);
                    }
                }

                /**
                 * Загружался ли уже виджет
                 * @param name
                 * @returns {boolean}
                 */

            }, {
                key: "exist",
                value: function exist(name) {
                    return this.currentWidgets.indexOf(name) !== -1;
                }
            }]);

            return WidgetStorage;
        }();

        module.exports = WidgetStorage;
    }, {}], 9: [function (require, module, exports) {
        var ModalManager = require('./modal/ModalManager');
        var modalParams = require('./modal/ModalParams');
        var modalButtonParams = require('./modal/ModalButton');

        // modal
        var manager = new ModalManager();
        var modal = {
            /**
             * @param {ModalParams} params
             * @param {boolean} ignoreLock
             */
            open: function open(params) {
                var ignoreLock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                manager.open(params, ignoreLock);
            },
            /**
             * @param {jQuery} $child
             * @return {boolean}
             */
            closeParent: function closeParent($child) {
                var item = manager.getOpenedNowModalItemByChild($child);
                if (item) {
                    manager.close(null, item.targetSelector);
                    return true;
                }
                return false;
            },
            /**
             * Must be called before openPopup
             * (in case both called at the same time "close_popup(selector)" and "open_popup")
             * @param targetSelector - ignored, everytime will be closed top m-popup
             */
            close: function close(targetSelector) {
                manager.close(null, targetSelector);
            },
            Params: modalParams.Params,
            buttons: {
                Button: modalButtonParams.Button,
                positions: modalButtonParams.positions,
                types: modalButtonParams.types
            },
            contentPosition: modalParams.contentPosition,
            contentTheme: modalParams.contentTheme
        };

        module.exports = modal;
    }, { "./modal/ModalButton": 10, "./modal/ModalManager": 12, "./modal/ModalParams": 13 }], 10: [function (require, module, exports) {
        var BUTTON_POSITION_TOP = 'top';
        var BUTTON_POSITION_BOTTOM = 'bottom';

        var BUTTON_TYPE_ACTION = 'action';
        var BUTTON_TYPE_BACK = 'back';

        function getButtonHeight(type) {
            return type === BUTTON_TYPE_ACTION ? 65 : 45;
        }

        var ModalButton = function () {
            function ModalButton(data) {
                _classCallCheck(this, ModalButton);

                this.type = data.type;
                this.position = 'position' in data ? data.position : BUTTON_POSITION_BOTTOM;

                this.label = 'label' in data ? data.label : '';
                this.onClick = typeof data.onClick === 'function' ? data.onClick : null;
                this.isCloseModalByClick = 'isCloseModalByClick' in data ? data.isCloseModalByClick : true;
                this.cssClass = 'cssClass' in data ? data.cssClass : '';
                /**
                 * Добавить отступ контента сверху/снизу (в зависимости от положения кнопки)
                 * Отступ добавляется на высоту кнопки
                 * @type {boolean}
                 */
                this.addContentOffset = 'addContentOffset' in data ? data.addContentOffset : false;

                this._createInstance();
                this.buttonHeight = getButtonHeight(this.type);
                this._attachHandlers();
            }

            _createClass(ModalButton, [{
                key: "getObject",
                value: function getObject() {
                    return this._instance;
                }
            }, {
                key: "addCloseTargetSelector",
                value: function addCloseTargetSelector(selector) {
                    this.closeTargetSelector = selector;
                }
            }, {
                key: "_attachHandlers",
                value: function _attachHandlers() {
                    var _this7 = this;

                    var self = this;
                    this._instance.click(function () {
                        if (self.isCloseModalByClick) {
                            window.modal.close(_this7.closeTargetSelector);
                        }

                        if (self.onClick) {
                            self.onClick();
                        }
                    });
                }
            }, {
                key: "_createInstance",
                value: function _createInstance() {
                    var typeCssClass = this.type === BUTTON_TYPE_BACK ? 'btn-back' : 'action-button';
                    var html = "<button type=\"button\" class=\"m-popup-external-button " + typeCssClass + " " + this.cssClass + "\">" + this.label + "</button>";
                    this._instance = $(html);
                }
            }, {
                key: "getOffset",
                value: function getOffset() {
                    return {
                        position: this.position,
                        value: this.position === BUTTON_POSITION_TOP ? this.buttonHeight - 2 : 0
                    };
                }
            }]);

            return ModalButton;
        }();

        module.exports = {
            Button: ModalButton,
            types: {
                ACTION: BUTTON_TYPE_ACTION,
                BACK: BUTTON_TYPE_BACK
            },
            positions: {
                TOP: BUTTON_POSITION_TOP,
                BOTTOM: BUTTON_POSITION_BOTTOM
            }
        };
    }, {}], 11: [function (require, module, exports) {
        var MODAL_IN_CSS_CLASS = 'in';
        var CONTENT_THEME_DEFAULT = 'default';

        var ModalItem = function () {
            /**
             * @param {ModalParams} params
             */
            function ModalItem(params) {
                _classCallCheck(this, ModalItem);

                this.params = params;

                this.targetSelector = params.target;
                this.zIndex = params.zIndex;

                this.url = params.url;
                this.title = params.title;
                this.contentDetachSelectorId = '';
                this.$contentDetachedParent = null;
                if (params.contentDetachSelectorId.length) {
                    var $content = $('#' + params.contentDetachSelectorId);
                    this.contentDetachSelectorId = params.contentDetachSelectorId;
                    this.$contentDetachedParent = $content.parent();
                    this.content = $content.detach();
                } else {
                    this.content = params.content;
                }
                this.fixSiteHeader = params.fixSiteHeader;
                this.needRemove = params.isNeedRemoveModal();

                this.onAfterShow = typeof params.onAfterShow === 'function' ? params.onAfterShow : null;
                this.onBeforeClose = typeof params.onBeforeClose === 'function' ? params.onBeforeClose : null;
                this.onBeforeRemove = typeof params.onBeforeRemove === 'function' ? params.onBeforeRemove : null;

                this._contentPosition = this.params.getContentPosition();

                this.$modal = $(this.targetSelector);
                this.$modal.data('targetSelector', this.targetSelector);
                this.$elems = {
                    content: this.$modal.find('.m-popup-content'), // scrollable
                    header: this.$modal.find('.m-popup-header'),
                    body: this.$modal.find('.m-popup-body'),
                    title: this.$modal.find('.m-popup-header .title'),
                    fixedClosePopupButton: null
                };
                this.externalButtons = params.externalButtons;
            }

            _createClass(ModalItem, [{
                key: "show",
                value: function show() {
                    var _this8 = this;

                    var self = this;
                    if (this.zIndex) {
                        this.$modal.css('z-index', this.zIndex);
                    }

                    ['top', 'bottom'].forEach(function (position) {
                        if (_this8.params.contentPadding[position] > 0) {
                            _this8.$elems.content.css('padding-' + position, _this8.params.contentPadding[position]);
                        }
                    });

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = this.externalButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var button = _step.value;

                            button.addCloseTargetSelector(self.targetSelector);
                            this.$modal.after(button.getObject());
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    var bodyClassList = 'oh m-popup-shown';
                    var modalClassList = 'open ' + this._contentPosition;
                    if (this.fixSiteHeader) {
                        modalClassList += ' after-site-header';
                        bodyClassList += ' site-header-fixed';
                        this.$modal.one('hidden.mpopup', function () {
                            var cntAfterHeaderShown = $('.m-popup.in.after-site-header').length;
                            if (cntAfterHeaderShown < 2) {
                                $('body').removeClass('site-header-fixed');
                            }
                            self.$modal.removeClass('after-site-header');
                        });
                    }
                    if (this.$elems.header.length) {
                        if (this.params.showHeader === false) {
                            this.$elems.header.addClass('hidden');
                        }
                    }

                    $('body').addClass(bodyClassList);
                    this.$modal.removeClass(window.modal.Params.getAvailableContentTypes().join(' '));
                    this.$modal.addClass(modalClassList);

                    if (this.params.contentTheme !== CONTENT_THEME_DEFAULT) {
                        this.$elems.content.addClass('theme-' + this.params.contentTheme);
                    }

                    setTimeout(function () {
                        self.$modal.addClass(MODAL_IN_CSS_CLASS);
                    }, 10);
                }
            }, {
                key: "loadContent",
                value: function loadContent() {
                    var self = this;
                    // Бывает, что всплывашка не была закрыта, а в нее просто будет загружен новый контент
                    // И поэтому нужно удалить старые карты
                    if (typeof window.removeAllMapsInElement === 'function') {
                        window.removeAllMapsInElement(this.$modal);
                    }

                    this.$modal.trigger('show.mpopup');
                    if (this.url.length) {
                        self.$elems.body.html(app.templates.circleLoading).load(this.url, function (data, status) {
                            if (self.onAfterShow) {
                                self.onAfterShow(self.$modal);
                            }
                            if (status === "error") {
                                self.showError({
                                    header: self.$elems.header,
                                    content: self.$elems.body,
                                    text: data
                                });
                            }
                            self.$modal.trigger('shown.mpopup');
                        });
                    } else {
                        if (this.content.length) {
                            this.$elems.body.html(this.content);
                        }
                        if (this.onAfterShow) {
                            this.onAfterShow(this.$modal);
                        }
                        this.$modal.trigger('shown.mpopup');
                    }

                    return true;
                }
            }, {
                key: "showError",
                value: function showError(params) {
                    var $content = params.content;
                    var text = params.text || 'Попробуйте позднее';

                    $content.html('<div class="site-error side-indent text-center">' + '<div class="site-header fw-b">Ошибка</div>' + '<div class="site-error-description pt-15">' + text + '</div>' + '</div>');
                }
            }, {
                key: "hide",
                value: function hide() {
                    var _this9 = this;

                    var self = this;
                    var $body = $('body');

                    var animationDuration = this.params.getAnimationDuration();
                    // Hide started
                    self.$modal.trigger('hide.mpopup');

                    // В основном для yandex карт
                    if (typeof window.removeAllMapsInElement === 'function') {
                        removeAllMapsInElement(self.$modal);
                    }
                    if (typeof self.onBeforeClose === 'function') {
                        self.onBeforeClose(self.$modal);
                    }

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = this.externalButtons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var button = _step2.value;

                            button.getObject().remove();
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    self.$modal.removeClass(MODAL_IN_CSS_CLASS);
                    setTimeout(function () {
                        self.$modal.removeClass('open');
                        var $openedPopups = $('.m-popup.open');
                        if (!$openedPopups.length) {
                            $body.removeClass('oh m-popup-shown');
                        }

                        // hidden
                        self.$modal.trigger('hidden.mpopup');

                        if (self.contentDetachSelectorId.length) {
                            self.$contentDetachedParent.html($('#' + _this9.contentDetachSelectorId).detach());
                        }

                        if (self.needRemove) {
                            if (typeof self.onBeforeRemove === 'function') {
                                self.onBeforeRemove(self.$modal);
                            }

                            self.$modal.remove();
                        }
                    }, animationDuration);
                }

                // Корректный селектор

            }, {
                key: "isTargetValid",
                value: function isTargetValid() {
                    return this.$modal.length && this.$modal.hasClass('m-popup');
                }
            }]);

            return ModalItem;
        }();

        module.exports = ModalItem;
    }, {}], 12: [function (require, module, exports) {
        var ModalItem = require('./ModalItem');
        var ModalParams = require('./ModalParams').Params;
        var itemRender = require('./modal-item-render');

        var ModalManager = function () {
            function ModalManager() {
                _classCallCheck(this, ModalManager);

                if (window.modal) {
                    throw new Error('only one instance of ModalManager available');
                }
                this.loadingTimestamp = new Date().getTime();
                // Поддерживаем ли работу с history API
                this.isHistorySupported = typeof window.history !== 'undefined';

                // Когда идет одновременно закрытие history.go(-1) и открытие history.pushState({...})
                // Блочим открытие до момента, пока не закончится закрытие
                this.historyPushLockTimer = null;
                // Если пытались что-то открыть в момент, пока открытие было заблочено - откладываем
                this.delayedOpenExecution = [];

                this.zIndex = 1000;
                this.visibleCount = 0;
                this.shownCount = 0;
                this.openedItemsByIndex = {};

                // Отслеживаем только после загрузки страницы
                // По history.state нельзя ориентироваться. На момент собыния popstate уже новое состояние
                this.currentHistoryState = null;

                // От срабатывания несколько раз .go(-1)
                this.popupCloseLocked = {};

                /**
                 * @type {ModalItem}
                 */
                this.closeTargetItem = null;

                this.attachHandlers();
            }

            /**
             *
             * @param {ModalParams} params
             * @param {!boolean} ignoreLock
             * @return {boolean}
             */


            _createClass(ModalManager, [{
                key: "open",
                value: function open(params, ignoreLock) {
                    var self = this;
                    if (this.isHistorySupported) {
                        ignoreLock = typeof ignoreLock !== 'boolean' ? false : ignoreLock;
                        if (this.historyPushLockTimer && !ignoreLock) {
                            // Откладываем выполнение
                            this.delayedOpenExecution.push(function () {
                                self.open(params, true);
                            });
                            return false;
                        }
                    }

                    if (params.isNeedCreateModal()) {
                        var customParams = params.getModalRenderParams(this.shownCount);
                        params.setTargetSelector('#' + customParams.id);
                        $('body').append(itemRender(customParams));
                    }

                    params.zIndex = this.zIndex++;
                    var modalItem = new ModalItem(params);
                    if (!modalItem.isTargetValid()) {
                        return false;
                    }

                    modalItem.show();
                    // Если модалка не показана
                    if (!this._isOpenedNow(modalItem)) {
                        this.visibleCount++;
                        this.shownCount++;

                        this.openedItemsByIndex[this.shownCount] = modalItem;

                        modalItem.$modal.data('shown-index', this.shownCount);
                        if (this.isHistorySupported) {
                            // Была закрыта. Показываем
                            this._unlockClose(modalItem.targetSelector);
                            history.pushState({
                                type: 'm-popup',
                                index: this.shownCount,
                                sessionTimestamp: this.loadingTimestamp
                            }, document.title);
                        }
                    } else {
                        // Закрываем все что открыто после,
                        // Чтобы вернуть history.state к состоянию текущей модалки
                        // TODO:
                    }
                    modalItem.loadContent();

                    return true;
                }

                /**
                 * Закрытие модалки с кнопки в интерфейсе
                 * @param $self - элемент, по которому нажали
                 * @param {*} popupSelector - Не используется при включенной истории
                 */

            }, {
                key: "close",
                value: function close($self, popupSelector) {
                    var $popup = null;
                    if (typeof popupSelector !== 'undefined' && popupSelector.length) {
                        $popup = $(popupSelector);
                    } else {
                        $popup = $self.closest('.m-popup');
                    }

                    popupSelector = $popup.data('targetSelector');
                    var targetModalItem = this._getOpenedModalItemByJqueryElement($popup);
                    if (this.isHistorySupported) {
                        if (this.haveOpened()) {
                            var currentState = this._parseCurrentState();
                            var closeTargetSelector = currentState.targetModalItem.targetSelector;
                            if (!targetModalItem) {
                                console.warn('target modal "%s" is not opened', popupSelector);
                                console.warn('last opened now is "%s"', closeTargetSelector);
                            } else {
                                if (closeTargetSelector !== targetModalItem.targetSelector) {
                                    console.warn('target modal "%s" is opened (not last opened)', popupSelector);
                                    console.warn('last opened now is "%s"', closeTargetSelector);
                                }
                            }
                            if (!$popup.hasClass('in')) {
                                // Если модалка, в которой нажали кнопку или передали как селектор, закрыта
                                console.warn('blocked close for "%s"', closeTargetSelector);
                                return;
                            }
                        }
                        // Закрываем последнюю открытую
                        this._closeLast();
                    } else {
                        this.closeTargetItem = targetModalItem;
                        this._runClose();
                    }

                    return true;
                }
            }, {
                key: "_closeLast",
                value: function _closeLast() {
                    if (!this.isHistorySupported) {
                        return false;
                    }
                    var self = this;
                    var currentState = this._parseCurrentState();
                    if (currentState.targetModalItem) {
                        // От двойных срабатываний .go(-1) при закрытии одной и той же модалки
                        // При следующем открытии снимаем флаг
                        if (!this._isCloseLocked(currentState.targetModalItem.targetSelector)) {
                            this._lockClose(currentState.targetModalItem.targetSelector);

                            if (this.historyPushLockTimer) {
                                clearTimeout(this.historyPushLockTimer);
                                this.historyPushLockTimer = null;
                            }

                            this.historyPushLockTimer = setTimeout(function () {
                                self._onAfterHistoryPushUnlock();
                            }, 10);
                            // Закрытие в popstate
                            // Закрывает модалку из this._parseCurrentState();
                            history.go(-1);

                            return true;
                        }
                    }

                    return false;
                }
            }, {
                key: "_runClose",
                value: function _runClose() {
                    var modalItem = this.closeTargetItem;
                    if (!modalItem || !this._isOpenedNow(modalItem)) {
                        return false;
                    }
                    var openedModalIndex = modalItem.$modal.data('shown-index');
                    delete this.openedItemsByIndex[openedModalIndex];
                    if (this.visibleCount) {
                        this.visibleCount--;
                    }
                    if (this.visibleCount === 0) {
                        this.openedItemsByIndex = {};
                    }
                    // Set default
                    this.closeTargetItem = null;

                    modalItem.hide();
                }
            }, {
                key: "haveOpened",
                value: function haveOpened() {
                    return this.visibleCount > 0;
                }
            }, {
                key: "attachHandlers",
                value: function attachHandlers() {
                    var _this10 = this;

                    if (this.isHistorySupported) {
                        this._attachHistoryStateHandlers();
                    }
                    $(document).ready(function () {
                        _this10._attachDOMHandlers();
                    });
                }
            }, {
                key: "_attachDOMHandlers",
                value: function _attachDOMHandlers() {
                    var self = this;
                    $('body').on('click', '.m-popup__close', function (e) {
                        self.close($(e.currentTarget));
                    }).on('click', '.m-popup-overlay', function (e) {
                        self.close($(e.currentTarget));
                    }).on('click', '.m-popup__open', function () {
                        var $self = $(this);
                        var params = new ModalParams($self.data());
                        self.open(params);
                    });
                }
            }, {
                key: "_attachHistoryStateHandlers",
                value: function _attachHistoryStateHandlers() {
                    if (!this.isHistorySupported) {
                        return false;
                    }

                    var self = this;
                    (function (history) {
                        var pushState = history.pushState;
                        history.pushState = function (state) {
                            self._onPushState({
                                state: state
                            });
                            return pushState.apply(history, arguments);
                        };
                    })(window.history);

                    window.addEventListener('popstate', function (e) {
                        self._onPopState(e);
                    }, false);

                    return true;
                }
            }, {
                key: "_onPushState",
                value: function _onPushState(e) {
                    this.currentHistoryState = e.state;
                }
            }, {
                key: "_onPopState",
                value: function _onPopState(e) {
                    // Предыдущее состояние, до popstate
                    var previousState = this._parseCurrentState();
                    // Обновляем текущее состояние истории
                    this.currentHistoryState = e.state;

                    if (this.haveOpened() && previousState.isCurrentSessionState && previousState.targetModalItem) {
                        // Если в предудущем состоянии была наша модалка - закрываем
                        this.closeTargetItem = previousState.targetModalItem;
                        this._runClose();
                    }
                }
            }, {
                key: "_parseCurrentState",
                value: function _parseCurrentState() {
                    var state = this.currentHistoryState;
                    var isModalState = state !== null && (typeof state === "undefined" ? "undefined" : _typeof(state)) === 'object' && state.type === 'm-popup';
                    var isCurrentSessionState = isModalState && state.sessionTimestamp === this.loadingTimestamp;

                    return {
                        isModalState: isModalState,
                        isCurrentSessionState: isCurrentSessionState,
                        targetModalItem: isCurrentSessionState ? this._getOpenedModalItemByIndex(state.index) : null
                    };
                }

                /**
                 *
                 * @param index
                 * @return {ModalItem|null}
                 * @private
                 */

            }, {
                key: "_getOpenedModalItemByIndex",
                value: function _getOpenedModalItemByIndex(index) {
                    return this.openedItemsByIndex[index] || null;
                }

                /**
                 *
                 * @param $modal
                 * @return {ModalItem|null}
                 * @private
                 */

            }, {
                key: "_getOpenedModalItemByJqueryElement",
                value: function _getOpenedModalItemByJqueryElement($modal) {
                    var openedModalIndex = $modal.length && $modal.hasClass('m-popup') ? $modal.data('shown-index') : null;
                    var modalItem = this._getOpenedModalItemByIndex(openedModalIndex);
                    if (modalItem && this._isOpenedNow(modalItem)) {
                        return modalItem;
                    }

                    return null;
                }

                /**
                 * @param {jQuery} $child
                 * @return {ModalItem|null}
                 */

            }, {
                key: "getOpenedNowModalItemByChild",
                value: function getOpenedNowModalItemByChild($child) {
                    return this._getOpenedModalItemByJqueryElement($child.closest('.m-popup'));
                }
            }, {
                key: "_onAfterHistoryPushUnlock",
                value: function _onAfterHistoryPushUnlock() {
                    var len = this.delayedOpenExecution.length;
                    if (len) {
                        var i = void 0;
                        for (i = 0; i < len; i++) {
                            this.delayedOpenExecution[i]();
                        }
                        this.delayedOpenExecution = [];
                    }
                    this.historyPushLockTimer = null;
                }

                // Для одной и той же модалки не делать go(-1) несколько раз,
                // пока снова не будет записи в источрии

            }, {
                key: "_lockClose",
                value: function _lockClose(popupSelector) {
                    this.popupCloseLocked[popupSelector] = 1;
                }

                // При новом открытии, вместе с pushState

            }, {
                key: "_unlockClose",
                value: function _unlockClose(popupSelector) {
                    this.popupCloseLocked[popupSelector] = 0;
                }

                // Уже вызвано событие закрытия для этой модалки.
                // Пока не закроется не вызывать history.go(-1) для этой модалки

            }, {
                key: "_isCloseLocked",
                value: function _isCloseLocked(popupSelector) {
                    return this.popupCloseLocked.hasOwnProperty(popupSelector) && this.popupCloseLocked[popupSelector] === 1;
                }
            }, {
                key: "_isOpenedNow",
                value: function _isOpenedNow(modalItem) {
                    var shownIndex = modalItem.$modal.data('shown-index');
                    // if popup was shown sometime ago OR was shown and closed at least once
                    return shownIndex && this.openedItemsByIndex.hasOwnProperty(shownIndex);
                }
            }]);

            return ModalManager;
        }();

        module.exports = ModalManager;
    }, { "./ModalItem": 11, "./ModalParams": 13, "./modal-item-render": 14 }], 13: [function (require, module, exports) {
        var CONTENT_FULL = 'full'; // весь экран
        var CONTENT_TOP = 'top'; // сверху, height: auto
        var CONTENT_BOTTOM = 'bottom'; // снизу, height: auto
        var CONTENT_MIDDLE = 'middle'; // в середине окна, height: auto, max-height: ...
        var CONTENT_FLOATING = 'floating'; // снизу + отступ, height: auto, max-height: ...

        var CONTENT_THEME_DEFAULT = 'default';
        var CONTENT_THEME_FIND_FORM = 'find-form';

        var i18nMessages = window.modalTranslations.i18nMessages;

        var ModalParams = function () {
            function ModalParams(data) {
                _classCallCheck(this, ModalParams);

                this.zIndex = null;
                this.target = null; // selector

                this.url = '';
                /**
                 * @type {string|object} - object === $(...)
                 */
                this.content = '';
                this.contentDetachSelectorId = '';
                this.fixSiteHeader = false;

                this.title = i18nMessages.goBack;
                this.cssClass = '';

                /**
                 * Выполнить после загрузки контента в модалку
                 * @type {Function|null}
                 */
                this.onAfterShow = null;

                /**
                 * Выполнить перед полным закрытием модалки (перед display: none)
                 * @type {Function|null}
                 */
                this.onBeforeClose = null;
                /**
                 * Выполнить перед удалением модалки. Если модалка не удаляется - колбек не будет вызван
                 * @type {Function|null}
                 */
                this.onBeforeRemove = null;

                /**
                 * Шапка модалки
                 * @type {boolean}
                 */
                this.showHeader = true;
                this._contentPosition = CONTENT_FULL;

                this.createModal = true;
                this.needRemove = true;

                this.contentTheme = CONTENT_THEME_DEFAULT;
                this.externalButtons = [];
                // При значении 0 - остается паддинг, заданный в css
                this.contentPadding = {
                    top: 0,
                    bottom: 0
                };

                this._load(data);
            }

            /**
             * Добавление внешней кнопки
             * @param button
             */


            _createClass(ModalParams, [{
                key: "addExternalButton",
                value: function addExternalButton(button) {
                    this.externalButtons.push(button);
                }

                /**
                 * @param {{}} data - e.g. $elem.data()
                 */

            }, {
                key: "_load",
                value: function _load(data) {
                    if (!window.utils.isObject(data)) {
                        return false;
                    }

                    if (data.hasOwnProperty('url')) {
                        this.url = data.url;
                    }
                    if (data.hasOwnProperty('title')) {
                        this.title = data.title;
                    }
                    if (window.utils.isObject(data.contentPadding)) {
                        this.contentPadding.top = Number(data.contentPadding.top) || 0;
                        this.contentPadding.bottom = Number(data.contentPadding.bottom) || 0;
                    }

                    if (data.hasOwnProperty('content')) {
                        this.content = data.content;
                    } else if (data.hasOwnProperty('contentDetachSelectorId')) {
                        this.contentDetachSelectorId = data.contentDetachSelectorId;
                    }

                    if (data.hasOwnProperty('header')) {
                        this.showHeader = !!data.header;
                    }
                    if (data.hasOwnProperty('contentPosition')) {
                        this.setContentPosition(data.contentPosition);
                    }
                    if (data.hasOwnProperty('fixSiteHeader')) {
                        this.fixSiteHeader = !!data.fixSiteHeader;
                    }
                    if (typeof data.onAfterShow === 'function') {
                        this.onAfterShow = data.onAfterShow;
                    }
                    if (typeof data.onBeforeClose === 'function') {
                        this.onBeforeClose = data.onBeforeClose;
                    }
                    if (typeof data.onBeforeRemove === 'function') {
                        this.onBeforeRemove = data.onBeforeRemove;
                    }
                    if (data.hasOwnProperty('target')) {
                        this.target = data.target;
                        this.createModal = false;
                    } else {
                        if (data.hasOwnProperty('cssClass')) {
                            this.cssClass = data.cssClass;
                        }
                    }

                    return true;
                }

                /**
                 * @param {string} theme
                 */

            }, {
                key: "setContentTheme",
                value: function setContentTheme(theme) {
                    this.contentTheme = theme;
                }
            }, {
                key: "setTargetSelector",
                value: function setTargetSelector(selector) {
                    this.target = selector;
                }
            }, {
                key: "isNeedRemoveModal",
                value: function isNeedRemoveModal() {
                    return this.createModal;
                }
            }, {
                key: "isNeedCreateModal",
                value: function isNeedCreateModal() {
                    return this.createModal;
                }
            }, {
                key: "getModalRenderParams",
                value: function getModalRenderParams(uniqueId) {
                    return {
                        id: 'm-popup-custom-' + uniqueId,
                        cssClass: this.cssClass,
                        showHeader: this.showHeader,
                        // При показе снизу/по центру
                        title: this._isFloating() || this._isOnBottom() ? null : this.title
                    };
                }

                /**
                 * @param {string} contentPosition
                 */

            }, {
                key: "setContentPosition",
                value: function setContentPosition(contentPosition) {
                    if (ModalParams.isPositionAvailable(contentPosition)) {
                        this._contentPosition = contentPosition;
                    } else {
                        console.error('unknown contentType = %s', contentPosition);
                    }
                }
            }, {
                key: "getContentPosition",
                value: function getContentPosition() {
                    return this._contentPosition;
                }
            }, {
                key: "getAnimationDuration",
                value: function getAnimationDuration() {
                    var animationDurations = {};
                    animationDurations[CONTENT_FULL] = 200;
                    animationDurations[CONTENT_MIDDLE] = 200;
                    animationDurations[CONTENT_FLOATING] = 200;
                    animationDurations[CONTENT_BOTTOM] = 200;
                    animationDurations[CONTENT_TOP] = 200;

                    return animationDurations[this._contentPosition];
                }
            }, {
                key: "_isOnBottom",
                value: function _isOnBottom() {
                    return this._contentPosition === CONTENT_BOTTOM;
                }
            }, {
                key: "_isFloating",
                value: function _isFloating() {
                    return [CONTENT_FLOATING, CONTENT_MIDDLE].indexOf(this._contentPosition) !== -1;
                }
            }], [{
                key: "getAvailableContentTypes",
                value: function getAvailableContentTypes() {
                    return [CONTENT_FULL, CONTENT_MIDDLE, CONTENT_TOP, CONTENT_BOTTOM, CONTENT_FLOATING];
                }

                /**
                 * @param {string|null} contentPosition
                 */

            }, {
                key: "isPositionAvailable",
                value: function isPositionAvailable(contentPosition) {
                    return ModalParams.getAvailableContentTypes().indexOf(contentPosition) !== -1;
                }
            }]);

            return ModalParams;
        }();

        module.exports = {
            Params: ModalParams,
            contentTheme: {
                'default': CONTENT_THEME_DEFAULT,
                findForm: CONTENT_THEME_FIND_FORM
            },
            contentPosition: {
                FULL: CONTENT_FULL,
                MIDDLE: CONTENT_MIDDLE,
                TOP: CONTENT_TOP,
                BOTTOM: CONTENT_BOTTOM,
                FLOATING: CONTENT_FLOATING
            }
        };
    }, {}], 14: [function (require, module, exports) {
        function renderHeader(title) {
            if (title !== null) {
                return '<div class="m-popup-header bg-medium-blue text-center">' + '<button type="button" class="m-popup-back-button m-popup__close" aria-label="Назад">' + '</button>' + '<div class="title">' + title + '</div>' + '</div>';
            } else {
                return '<div class="m-popup-header m-popup-cross-button m-popup__close" role="button">' + '<span class="sr-only">Закрыть</span>' + '</div>';
            }
        }

        /**
         * @param {{}} params
         * @return {string}
         */
        module.exports = function (params) {
            return '<div id="' + params.id + '" class="m-popup ' + params.cssClass + '">' + '<div class="m-popup-overlay" role="button"></div>' + '<div class="m-popup-content">' + (params.showHeader ? renderHeader(params.title) : '') + '<div class="m-popup-body"></div>' + '</div>' + '</div>';
        };
    }, {}], 15: [function (require, module, exports) {
        var Popover = function () {
            /**
             * @param {jQuery} $container
             * @param {string} content
             * @param {{theme: [string], cssClass: [string], onAfterShow: [Function], onAfterClose: [Function]}} params
             */
            function Popover($container, content) {
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                _classCallCheck(this, Popover);

                this.$container = $container;
                this.onAfterShow = typeof params.onAfterShow === 'function' ? params.onAfterShow : null;
                this.onAfterClose = typeof params.onAfterClose === 'function' ? params.onAfterClose : null;

                if (this.$container.length) {
                    this.createInstance(content, 'theme' in params ? params.theme : 'default', 'cssClass' in params ? params.cssClass : 'cssClass');
                    // show
                    this.$container.append(this.$instance);
                    if (this.onAfterShow !== null) {
                        this.onAfterShow(this);
                    }
                }
            }

            _createClass(Popover, [{
                key: "createInstance",
                value: function createInstance(content, theme, cssClass) {
                    var _this11 = this;

                    this.$instance = $("<div class=\"site-popover site-popover-" + theme + " " + cssClass + "\">\n                <div role=\"button\" class=\"site-popover__close\"><span class=\"sr-only\">\u0417\u0430\u043A\u0440\u044B\u0442\u044C</span></div>\n                <div class=\"site-popover-content\">" + content + "</div>\n                <span class=\"caret\"></span>\n            </div>");

                    // handlers
                    this.$instance.find('.site-popover__close').one('click', function () {
                        _this11.close();
                    });
                }
            }, {
                key: "close",
                value: function close() {
                    this.$instance.remove();
                    if (this.onAfterClose !== null) {
                        this.onAfterClose();
                    }
                }
            }]);

            return Popover;
        }();

        module.exports = {
            Popover: Popover
        };
    }, {}], 16: [function (require, module, exports) {
        var WidgetStorage = require('./WidgetStorage');

        widgetStorage = new WidgetStorage();

        module.exports = widgetStorage;
    }, { "./WidgetStorage": 8 }] }, {}, [5]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        window.showPagePreloader = function () {
            $('body').addClass('disable-interaction').append('<div class="page-preloader">' + window.app.templates.dataLoading + '</div>');
        };

        /**
         * @param {string} formType
         * @param {string|null} contentPosition
         */
        window.openSearchForm = function () {
            var formType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
            var contentPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            contentPosition = window.modal.Params.isPositionAvailable(contentPosition) ? contentPosition : window.modal.contentPosition.TOP;
            window.modal.open(new window.modal.Params({
                contentPosition: contentPosition,
                contentDetachSelectorId: 'search-form-panel',
                onAfterShow: function onAfterShow() {
                    $('#search-form-panel').addClass('theme-' + formType);
                },
                onBeforeRemove: function onBeforeRemove() {
                    $('#search-form-panel').removeClass('theme-' + formType);
                }
            }));
        };

        window.openCallRequestModal = function (tourID) {
            var params = void 0;
            if (typeof tourID !== 'undefined') {
                params = {
                    contentPosition: window.modal.contentPosition.FLOATING,
                    contentDetachSelectorId: 'main-callback-form-content',
                    header: true,
                    onAfterShow: function onAfterShow($modal) {
                        window.utils.loadImages($modal, true, true);
                        $modal.addClass('callback-tour-layout');
                        window.utils.getShortTourId(tourID, $modal.find('.js-short-tour-id'));
                    },
                    onBeforeClose: function onBeforeClose($modal) {
                        $modal.removeClass('callback-tour-layout');
                    }
                };
            } else {
                params = {
                    contentDetachSelectorId: 'main-callback-form-content',
                    contentPosition: window.modal.contentPosition.TOP,
                    header: false
                };
            }
            window.modal.open(new window.modal.Params(params));
        };

        window.openTourPromoModal = function (tourID) {
            var params = void 0;
            if (typeof tourID !== 'undefined') {
                params = {
                    contentPosition: window.modal.contentPosition.FLOATING,
                    contentDetachSelectorId: 'tour-promo-content',
                    header: false,
                    onAfterShow: function onAfterShow($modal) {
                        window.utils.loadImages($modal, true, true);
                        $modal.addClass('tour-promo-layout').data('id', tourID);
                        window.getTourLink(tourID, '.btn-order-in-app');
                        window.getTourLink(tourID, '.tour-in-app');
                    },
                    onBeforeClose: function onBeforeClose($modal) {
                        $modal.removeClass('tour-promo-layout');
                    }
                };
            } else {
                params = {
                    contentDetachSelectorId: 'tour-promo-content',
                    contentPosition: window.modal.contentPosition.TOP,
                    header: false
                };
            }
            window.modal.open(new window.modal.Params(params));
        };

        /**
         * @param {number} cityId
         * @return {boolean}
         */
        window.changeSiteCity = function (cityId) {
            var $cityInput = $('#site-city-select');
            if (window.pseudoSelect.valueExist($cityInput, cityId) && Number($cityInput.val()) !== cityId) {
                $cityInput.trigger('psEvent.set', cityId);
                return true;
            }
            return false;
        };

        window.getTourLink = function (tourId, selector, from) {
            var element = $(selector);

            var data = {
                tourId: tourId
            };

            var currentUrl = window.location.href;
            var urlParams = new URLSearchParams(currentUrl);
            var fromParam = urlParams.get('from');

            if (fromParam) {
                data.from = fromParam;
            }

            $.ajax({
                url: "tours/get-link-on-tour",
                data: data,
                dataType: "json"
            }).done(function (data) {
                if (data.link) {
                    return element.attr('href', data.link);
                }

                return element.attr('href', '#');
            });
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        window.mobileTracking = {};
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var modal = window.modal;
        // first handlers
        (function () {
            // prevent anchor click
            $('body').on('click', 'a[href="#"]', function (e) {
                e.preventDefault();
            });
        })();

        $('.m-popup__open-search-form').on('click', function (event) {
            var formType = event.currentTarget.getAttribute('data-form-type') || 'default';
            window.openSearchForm(formType, event.currentTarget.getAttribute('data-position'));
        });

        $(window).on('load', function () {
            // Вызываем callback popup при входе клиента на сайт, для увеличения конверсии заявок
            var $callBackButton = $('.contacts-info-button__open');
            if (window.utils.cookies.get('city-detected-popup') && !window.utils.cookies.get('mobile-callback-popup') && $callBackButton.length > 0) {
                $callBackButton.trigger('click');
                var date = new Date();
                date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
                var expires = "expires=" + date.toUTCString();
                document.cookie = 'mobile-callback-popup=true; ' + expires + '; path=/';
            }
        });

        $(document).ready(function () {

            // Блок с pop-up для языка
            var $popUpLanguageBlock = $('.language-pop-up-info-block');
            var $menuButton = $('.btn-header-menu');
            var $closeButton = $popUpLanguageBlock.find('.close-button');
            // Проверяем, есть ли запись в localStorage о том, что блок был закрыт
            var isPopUpClosed = window.utils.isLocalStorageSupported ? localStorage.getItem('popUpForLanguageClosed') : null;
            // Если блок не закрывали, то показываем его через 1 секунду
            if (!isPopUpClosed) {
                setTimeout(function () {
                    $popUpLanguageBlock.css('display', 'block');
                    // Обработчик события клика на кнопку закрытия
                    $closeButton.one('click', function () {
                        // Закрываем блок
                        $popUpLanguageBlock.css('display', 'none');
                        // Записываем информацию в localStorage о том, что блок был закрыт
                        localStorage.setItem('popUpForLanguageClosed', 'true');
                    });
                    // Если не закрывают, а нажимают сразу на Меню тоже закроем
                    $menuButton.one('click', function () {
                        // Закрываем блок
                        $popUpLanguageBlock.css('display', 'none');
                        // Записываем информацию в localStorage о том, что блок был закрыт
                        localStorage.setItem('popUpForLanguageClosed', 'true');
                    });
                }, 1000);
            }

            $('.read-more').on('click', function () {
                var $selfButton = $(this);
                var $parent = $selfButton.closest('.text-preview');
                $parent.addClass('visible');
                $parent.find('.text-hidden').removeClass('text-hidden');
                if (parseInt($selfButton.data('toggle'), 10) !== 1) {
                    $selfButton.remove();
                }
            });

            $('.contacts-info-button__open').on('click', function () {
                var params = void 0;
                params = {
                    contentDetachSelectorId: 'contacts-info-menu',
                    contentPosition: window.modal.contentPosition.BOTTOM,
                    header: false
                };
                window.modal.open(new window.modal.Params(params));
            });

            // site texts collapse handlers
            $('[data-toggle="collapse"]').on('click', function (e) {
                e.preventDefault();
                var targetSelector = this.getAttribute('href');
                targetSelector = targetSelector && targetSelector !== '#' ? targetSelector : this.getAttribute('data-target');
                var $target = $(targetSelector);
                var isOpened = this.getAttribute('aria-expanded');
                if (isOpened === 'true') {
                    this.setAttribute('aria-expanded', 'false');
                    $target.removeClass('in');
                } else {
                    this.setAttribute('aria-expanded', 'true');
                    $target.addClass('in');
                }
            });

            // WHATSAPP
            $('body').on('click', '.whatsapp-button--textback', function (e) {
                window.tracking.setYaEvent('click.layoutWhatsappButton', true);
                // Открыть whatsapp
                if (window.textBackWidgetSDK.subscribeWhatsapp()) {
                    e.preventDefault();
                }
            }).one('change', '#site-currency', function () {
                window.showPagePreloader();
                $.post('/site/set-currency', { currency: this.value }).done(function () {
                    window.location.reload();
                });
            }).one('change', '#site-language', function () {
                window.showPagePreloader();
                $.post('/settings/set-language', { language: this.value }).done(function () {
                    window.location.reload();
                });
            })
            // site main menu
            .on('click', '.btn-header-menu', function () {
                var $self = $(this);
                var isOpened = $self.data('open') === 1;
                var cssClass = 'site-menu-popup';
                if (isOpened) {
                    window.modal.close('.' + cssClass);
                } else {
                    $self.data('open', 1);
                    var params = new modal.Params({
                        cssClass: cssClass,
                        header: false,
                        contentPosition: modal.contentPosition.TOP,
                        content: $('#site-menu').html(),
                        fixSiteHeader: true,
                        onBeforeClose: function onBeforeClose() {
                            $self.data('open', 0);
                        }
                    });
                    modal.open(params);
                }
            }).on('click', '.sub-menu__toggle', function () {
                var $subMenuWrapper = $(this).parent();
                var isOpenedNow = $subMenuWrapper.hasClass('open');
                if (isOpenedNow) {
                    $subMenuWrapper.removeClass('open');
                } else {
                    $('.sub-menu.open').removeClass('open');
                    $subMenuWrapper.addClass('open');
                }
            }).on('click', '.m-popup__open-callback', function () {
                var $siteMenuOpenBtn = $('.btn-header-menu');
                if ($siteMenuOpenBtn.data('open') === 1) {
                    $siteMenuOpenBtn.trigger('click');
                    setTimeout(function () {
                        window.openCallRequestModal();
                    }, 150);
                } else {
                    window.openCallRequestModal();
                }
            }).on('click', '.show-hidden-phone', function () {
                window.utils.showHiddenPhone(this);
                window.tracking.setYaEvent('click.hiddenPhone');
                window.tracking.setGAEvent('hiddenPhone', 'click');
            })
            // for now one event is enough
            .one('click', '.js-clickable-phone', function () {
                window.tracking.setYaEvent('click.onPhone');
                window.tracking.setGAEvent('sitePhone', 'click');
            }).on('click', '.js-footer-btn-subscribe', function () {
                var widgetName = 'subscription';
                var isWidgetExist = window.widgetStorage.exist(widgetName);
                var url = isWidgetExist ? '/subscription/modal?noJs' : '/subscription/modal';
                var params = new window.modal.Params({
                    url: url,
                    contentPosition: window.modal.contentPosition.FLOATING,
                    onAfterShow: function onAfterShow() {
                        window.widgetStorage.add(widgetName);
                    }
                });

                window.modal.open(params);
            }).on('click', '.call-request-button__open', function () {
                window.openCallRequestModal();
            });

            var $siteHeader = $('#site-header');
            if (Number($siteHeader.data('search')) === 1) {
                var showAfterScrollY = 100;
                var searchButtonsShown = false;
                $(window).on('scroll', function (e) {
                    if (e.currentTarget.scrollY > showAfterScrollY) {
                        if (!searchButtonsShown) {
                            searchButtonsShown = true;
                            $siteHeader.addClass('with-search-button');
                        }
                    } else {
                        if (searchButtonsShown) {
                            searchButtonsShown = false;
                            $siteHeader.removeClass('with-search-button');
                        }
                    }
                });
            }
        });
    }, {}] }, {}, [1]);